import { clsx } from 'clsx';
import { memo } from 'react';
import { Flex } from 'components/Flex';

import classes from './MCSChartItem.module.scss';

interface MCSChartItemProps {
  isActive?: boolean;
}

const MCSChartItem = (props: MCSChartItemProps) => {
  const { isActive } = props;

  return <Flex className={clsx(classes.chartItem, isActive && classes.active)} full grow />;
};

const MemoizedMCSChartItem = memo(MCSChartItem);

export default MemoizedMCSChartItem;
